export default __webpack_public_path__ + "static/media/whatsapp.232ad626.svg";